import { phoenixSearch } from '@phoenix/search/PhoenixSearch';

export const searchClient = phoenixSearch;
